/**
 * Created by hp on 2017/7/10.
 */
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {NavBar, NavBarItem} from 'react-weui'
import '../styles/components/WKTab.css'

class WKTab extends Component {
    constructor() {
        super();
        this.handleSelectTab = this.handleSelectTab.bind(this);
    }

    handleSelectTab(e) {
        let selId = e.target.dataset.id;
        this.props.dispatch({
            type: 'COMPONENT_SELECT_TAB',
            payload: selId
        });
    }

    render() {
        const { wkTabList } = this.props;

        return (
            <div className="wk-tab">
                <NavBar className="wk-tab-navbar">
                    {
                      wkTabList.map((item, _) => (
                        <NavBarItem 
                          data-id={item.id} 
                          key={'wk-tab-navbar-item' + item.id} 
                          className="wk-tab-navbar-item"
                          active={item.selected} 
                          onClick={this.handleSelectTab}
                        >
                            { item.name }
                        </NavBarItem>
                      ))
                    }
                </NavBar>
            </div>
        )
    }
}

export default connect((state) => ({
    wkTabList: state.component.wkTab.list,
    accountId: state.account.id,
}))(WKTab)


// WEBPACK FOOTER //
// ./src/components/WKTab.js